import AvdragsfrihetCard from './avdragsfrihet-card';

export default AvdragsfrihetCard;
